import type { UserStatus } from './types';

interface ProfileAccessFields {
  status?: string | null;
  account_status?: string | null;
  approval_status?: string | null;
  deleted_at?: string | null;
}

// Database activity and administrative approval are separate fields. Never infer
// approval from an active account or from a role alone.
export function profileAccessStatus(profile: ProfileAccessFields): UserStatus {
  const activity = profile.account_status ?? profile.status;
  if (profile.deleted_at || ['inactive', 'disabled', 'suspended', 'deleted'].includes(activity || '')) return 'inactive';
  if (profile.approval_status === 'rejected' || activity === 'rejected') return 'rejected';
  if (activity === 'active' && profile.approval_status === 'approved') return 'approved';
  return 'pending';
}

export function normalizeProfileUser<T extends ProfileAccessFields>(profile: T): T & { status: UserStatus; account_status: string | null } {
  return { ...profile, account_status: profile.account_status ?? profile.status ?? null, status: profileAccessStatus(profile) };
}

export function isApprovedProfile(profile: ProfileAccessFields | null | undefined): boolean {
  return !!profile && profileAccessStatus(profile) === 'approved';
}
